const prodConfig = require('./configure-store.prod');
const devConfig = require('./configure-store.dev');

if (process.env.NODE_ENV === 'production') {
  module.exports = prodConfig;
} else {
  module.exports = devConfig;
}
